// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__aYhWD","size-XS":"Button_size-XS__KVMgv","size-S":"Button_size-S__9ad6o","size-M":"Button_size-M__itN1J","size-L":"Button_size-L__D8gFk"};